<template>
<span v-html="formatted"></span>
</template>

<script>
import { formatRichText } from '@/utlis/richText';

export default {
  name: 'RichText',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    formatted() {
      return formatRichText(this.text);
    },
  },
};
</script>
